module.exports = __webpack_public_path__ + "static/media/M1-29-Ravyna-cod148.af064cc2.png";